module.exports = __webpack_public_path__ + "static/service_bg@2x-d6bc713ff863fd64a7b87fc7a5fec0fb.png";